import { Build as BuildIcon } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import VerifiedIcon from "@mui/icons-material/Verified";
import {
  Box,
  Button,
  Card,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Postrequestcall } from "../../request/Postrequest";
import { BIBlue, BIGrey, BILightGrey, BIRed, lightenHexColor } from "../../assets/helpers";
import AddProductModal from "../common/AddProductModal";
import Emptydata from "../common/Emptydata";
import Loader from "../../common/Loader";
import SearchField from "../common/SearchField";
import { FETCH_MANUFACTURER_PRODUCTS } from "../../constant/Apipath";
import { English } from "../../constant/EnglishFallback";
import Pages from "../../constant/ReportModel";
import { setShowReport } from "../../redux/actions/actions";
import FilterModal from "./FilterModal";

function ManufacturedProducts({
  id,
  scrollId,
  manufactureDetails,
  isVerified = false,
  color = "",
  allowPublicProductSubmission
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loginData, multiLanguageData, reportSuccess } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const LanguageData = multiLanguageData?.Manufacturers || {};

  const {
    TEXT_NO_DATA_INFO_SUBTEXT = English.Manufacturers.TEXT_NO_DATA_INFO_SUBTEXT,
    TEXT_NO_INFO = English.Manufacturers.TEXT_NO_INFO,
    TEXT_NO_RESULTS_FOUND = English.Manufacturers.TEXT_NO_RESULTS_FOUND,
    TEXT_ADD_PRODUCT = English.Manufacturers.TEXT_ADD_PRODUCT,
    BUTTON_REPORT = English.Manufacturers.BUTTON_REPORT,
    TEXT_SEARCH = English.Manufacturers.TEXT_SEARCH,
    TEXT_PRODUCTS = English.Manufacturers.TEXT_PRODUCTS,
    TEXT_ADD_PRODUCT_TO_MANUFACTURER = English.Manufacturers.TEXT_ADD_PRODUCT_TO_MANUFACTURER,
    TEXT_SEARCH_FILTER = English.Manufacturers.TEXT_SEARCH_FILTER,
    TEXT_NEW_FILTERS = English.Manufacturers.TEXT_NEW_FILTERS
  } = LanguageData || {};

  const debounceTimeout = useRef(null);
  const [productData, setProductData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearchLoader, setShowSearchLaoder] = useState(false);
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const [hasData, setHasData] = useState(false);
  const [product, setProduct] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [filterModalOpen, setFilterModalOpen] = useState(false);

  const [appliedFilters, setAppliedFilters] = useState({
    type: "All",
    verified: false,
    selectedGroup: null,
    selectedGroupChildren: [],
    properties: []
  });
  const [isFilterActive, setIsFilterActive] = useState(false);

  useEffect(() => {
    console.log("reportSuccess: ", reportSuccess);
    if (reportSuccess !== true) getInitialData();
  }, [reportSuccess]);

  const getInitialData = async () => {
    setIsLoading(true);
    await getProductData(searchTerm, 1, "fristTimeApiCall");
    setIsLoading(false);
  };

  const getProductData = async (
    searchTerm,
    pageNumber,
    fristTimeApiCall,
    filters = appliedFilters
  ) => {
    console.log("getProductData-> searchTerm: ", searchTerm, " pageNumber: ", pageNumber);
    try {
      setAllDataLoaded(true);

      const searchList = {
        manufacturerId: id
      };

      if (filters.verified) {
        searchList.verified = filters.verified;
      }

      if (filters.type && filters.type !== "All") {
        searchList.productType = filters.type;
      }

      if (filters.selectedGroup && filters.selectedGroupChildren.length === 0) {
        searchList.groupId = filters.selectedGroup;
      }

      if (filters.selectedGroupChildren && filters.selectedGroupChildren.length > 0) {
        searchList.childrenGroupIds = filters.selectedGroupChildren;
      }

      if (filters.properties && filters.properties.length > 0) {
        searchList.properties = filters.properties;
      }

      const obj = {
        PageNr: pageNumber,
        NrOfRecPerPage: 20,
        FullSearch: searchTerm ?? "",
        SearchList: [searchList],
        userId: currentUserId,
        IncludeRecordNr: true,
        SortList: [{}],
        FetchAllowedRecordsOnly: true,
        TypeOfObjectReturned: ""
      };

      const res = await Postrequestcall(FETCH_MANUFACTURER_PRODUCTS, obj, loginData?.accessToken);
      console.log("getProductData-> res: ", res);
      if (res.status === 200) {
        let resData = res?.data?.data?.sort((a, b) => a?.name?.localeCompare(b?.name)) ?? [];
        if (pageNumber > 1) {
          setTimeout(() => {
            setProductData((prevProducts) => [...prevProducts, ...resData]);
          }, 500);
        } else {
          setProductData(() => resData);
          if (fristTimeApiCall) {
            setHasData(resData?.length > 0);
          }
        }
      }
    } catch (error) {
      console.log("getProductData-> Error While Fetching Product Data: ", error);
    } finally {
      setShowSearchLaoder(false);
      setIsLoading(false);
      setAllDataLoaded(false);
    }
  };

  const handleOpenReportModal = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      name: Pages?.manufacturersProducts?.name,
      AppScreenId: Pages?.manufacturersProducts?.id,
      recordId: product.id ?? 0
    };

    dispatch(setShowReport(reportObj));
  };

  const onAddProductClick = () => {
    setShowAddProductModal(true);
  };

  const onItemClick = (item) => {
    navigate(`/product/${item?.id}`);
  };

  const onProductClick = (currentTarget, product) => {
    setProduct(product);
    setMoreMenuAnchorEl(currentTarget);
  };

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  const getFilterCount = () => {
    let count = 0;
    if (appliedFilters.type && appliedFilters.type !== "All") count++;
    if (appliedFilters.verified) count++;
    if (appliedFilters.selectedGroup && appliedFilters.selectedGroupChildren.length === 0) count++;
    if (appliedFilters.selectedGroupChildren && appliedFilters.selectedGroupChildren.length > 0) {
      count += appliedFilters.selectedGroupChildren.length;
    }
    if (appliedFilters.properties && appliedFilters.properties.length > 0) {
      count += appliedFilters.properties.length;
    }
    return count;
  };

  const filterCount = getFilterCount();
  const hasActiveFilters = filterCount > 0;

  const NoInformation = () => {
    return (
      <Box>
        <Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent={isVerified ? "space-between" : "end"}>
            {isVerified === true && (
              <Button
                onClick={() => {
                  setFilterModalOpen(true);
                }}
                sx={{
                  backgroundColor: hasActiveFilters ? lightenHexColor(color, 90) : "transparent",
                  color: hasActiveFilters ? color : BIGrey,
                  border: `1px solid ${!hasActiveFilters ? BILightGrey : "transparent"}`,
                  textTransform: "none"
                }}>
                {hasActiveFilters == true ? TEXT_NEW_FILTERS : TEXT_SEARCH_FILTER}
                {hasActiveFilters ? ` (${filterCount})` : ""}
                <KeyboardArrowDownIcon />
              </Button>
            )}
            {allowPublicProductSubmission !== false && (
              <Button onClick={onAddProductClick} sx={{ color: color }}>
                {TEXT_ADD_PRODUCT}
              </Button>
            )}
          </Stack>
          <Box>
            {isVerified === false && allowPublicProductSubmission !== false && (
              <Button
                onClick={onAddProductClick}
                sx={{ color: color, display: "flex", marginLeft: "auto" }}>
                {TEXT_ADD_PRODUCT}
              </Button>
            )}
            <Box className="empty-data-card">
              {isVerified === false ? (
                <Emptydata
                  icon={<BuildIcon className="emptydata-icon" />}
                  firstText={TEXT_NO_INFO}
                  secondText={TEXT_NO_DATA_INFO_SUBTEXT}
                />
              ) : (
                <Emptydata
                  icon={<BuildIcon className="emptydata-icon" />}
                  firstText={TEXT_NO_INFO}
                  secondText={TEXT_NO_RESULTS_FOUND}
                />
              )}
            </Box>
          </Box>
        </Stack>
      </Box>
    );
  };

  const renderListing = () => {
    return (
      <Box>
        <Stack gap={1}>
          <SearchField
            sx={{
              backgroundColor: "#EAEBEA",
              border: "none",
              borderRadius: "10px",
              "& .MuiFormControl-root": {
                border: "none"
              },
              "& .MuiOutlinedInput-root": {
                backgroundColor: "#EAEBEA",
                borderRadius: "5px",
                "& fieldset": {
                  border: "none"
                },
                "&:hover fieldset": {
                  border: "none"
                },
                "&.Mui-focused fieldset": {
                  border: "none"
                }
              },
              "& .MuiInputLabel-root": {
                color: BIGrey,
                "&.Mui-focused": {
                  color: BIBlue
                }
              }
            }}
            placeholder={`${TEXT_SEARCH} ${manufactureDetails?.name}'s ${TEXT_PRODUCTS}`}
            value={searchTerm}
            onChange={(value) => {
              setShowSearchLaoder(true);
              const searchValue = value;
              setSearchTerm(searchValue);
              if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
              }
              debounceTimeout.current = setTimeout(() => {
                getProductData(value, 1, "fristTimeApiCall");
              }, 1000);
            }}
            onSubmit={() => {
              setShowSearchLaoder(true);
              getProductData(searchTerm, 1, "fristTimeApiCall");
            }}
            size={"small"}
          />

          <Stack
            direction="row"
            justifyContent={isVerified ? "space-between" : "end"}
            alignItems="center">
            {isVerified === true && (
              <Button
                onClick={() => {
                  setFilterModalOpen(true);
                }}
                sx={{
                  backgroundColor: hasActiveFilters ? lightenHexColor(color, 90) : "transparent",
                  color: hasActiveFilters ? color : BIGrey,
                  border: `1px solid ${!hasActiveFilters ? BILightGrey : "transparent"}`,
                  textTransform: "none"
                }}>
                {hasActiveFilters == true ? TEXT_NEW_FILTERS : TEXT_SEARCH_FILTER}
                {hasActiveFilters ? ` (${filterCount})` : ""}
                <KeyboardArrowDownIcon />
              </Button>
            )}
            {allowPublicProductSubmission !== false && (
              <Button
                variant="text"
                sx={{ textTransform: "none", alignSelf: "flex-end", color: color }}
                onClick={onAddProductClick}>
                {TEXT_ADD_PRODUCT}
              </Button>
            )}
          </Stack>
        </Stack>
        <Stack mt={1} spacing={1}>
          {showSearchLoader ? (
            <Stack style={{ padding: "30px" }}>
              <Loader />
            </Stack>
          ) : productData?.length > 0 ? (
            <>
              <InfiniteScroll
                dataLength={productData?.length}
                next={async () => {
                  increaseOffset((pageNumber) => {
                    getProductData(searchTerm, pageNumber, null, appliedFilters);
                  });
                }}
                hasMore={true}
                loader={
                  !allDataLoaded ? null : (
                    <h4 style={{ display: "flex", justifyContent: "center" }}>
                      <Loader />
                    </h4>
                  )
                }
                scrollableTarget={scrollId}>
                <List disablePadding>
                  <Stack spacing={1}>
                    {productData.map((product) => (
                      <ListItem
                        disablePadding
                        key={product?.id ?? `${product?.productName}-${Math.random()}`}
                        style={{
                          padding: "0px",
                          border: `1px solid ${BILightGrey}`,
                          borderRadius: "5px"
                        }}
                        secondaryAction={
                          <IconButton
                            size="small"
                            onClick={(event) => onProductClick(event.currentTarget, product)}>
                            <MoreHorizIcon />
                          </IconButton>
                        }>
                        <ListItemButton
                          onClick={() => {
                            onItemClick(product);
                          }}>
                          <ListItemText
                            primary={
                              <Stack direction={"row"} alignItems="center" gap={1}>
                                {product?.name}
                                {product.verified && (
                                  <VerifiedIcon
                                    sx={{
                                      color: BIBlue,
                                      fontSize: "1.2rem"
                                    }}
                                  />
                                )}
                              </Stack>
                            }
                          />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </Stack>
                </List>
                <Menu
                  anchorEl={moreMenuAnchorEl}
                  open={Boolean(moreMenuAnchorEl)}
                  onClose={() => setMoreMenuAnchorEl(null)}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}>
                  <MenuItem onClick={() => handleOpenReportModal()} style={{ color: BIRed }} dense>
                    {BUTTON_REPORT}
                  </MenuItem>
                </Menu>
              </InfiniteScroll>
            </>
          ) : (
            <Stack
              direction={"row"}
              justifyContent={"center"}
              alignItems={"center"}
              style={{ color: BIGrey, padding: "30px" }}>
              {TEXT_NO_RESULTS_FOUND}
            </Stack>
          )}
        </Stack>
      </Box>
    );
  };

  return (
    <Box className="main-content-card-list">
      <Card className="pagelist-content" sx={{ p: 2, height: "100%" }}>
        {isLoading ? (
          <Loader fullScreen calc="calc(100vh - 240px)" />
        ) : hasData ? (
          renderListing()
        ) : (
          <NoInformation />
        )}
        {showAddProductModal && (
          <AddProductModal
            open={showAddProductModal}
            onClose={() => {
              setShowAddProductModal(false);
            }}
            from={"manufacture"}
            manufactureDetails={manufactureDetails}
            mainId={id}
            title={TEXT_ADD_PRODUCT_TO_MANUFACTURER}
            skipCompanyProductSave={true}
            onProductCreated={async () => {
              await getInitialData();
            }}
            lockManufacturerToCurrent={true}
            showCurrentManufacturerAction={false}
          />
        )}
      </Card>
      {filterModalOpen && (
        <FilterModal
          color={color}
          onApply={(filters) => {
            setAppliedFilters(filters);
            setIsFilterActive(true);
            setFilterModalOpen(false);
            getProductData(searchTerm, 1, "fristTimeApiCall", filters);
          }}
          onReset={() => {
            const resetFilters = {
              type: "All",
              verified: false,
              selectedGroup: null,
              selectedGroupChildren: [],
              properties: []
            };
            setAppliedFilters(resetFilters);
            setIsFilterActive(false);
            getProductData(searchTerm, 1, "fristTimeApiCall", resetFilters);
          }}
          open={filterModalOpen}
          setSearchTerm={setSearchTerm}
          onClose={(shouldApply, filters) => {
            if (shouldApply && filters) {
              setAppliedFilters(filters);
              setIsFilterActive(true);
              getProductData(searchTerm, 1, "fristTimeApiCall", filters);
            }
            setFilterModalOpen(false);
          }}
          initialFilters={appliedFilters}
          verifiedFilter={appliedFilters.verified}
          setVerifiedFilter={(verified) => {
            setAppliedFilters((prev) => ({ ...prev, verified }));
          }}
          manufacturerId={manufactureDetails?.id}
        />
      )}
    </Box>
  );
}

export default ManufacturedProducts;
